import React from 'react';
import { Badge } from '../ui/badge';
import { StatusBadge } from './StatusBadge';

export const DeliveryRow = ({ delivery }) => (
  <div className="flex items-center gap-4 py-3 border-b border-border/50 last:border-0">
    <StatusBadge status={delivery.status} />
    <div className="flex-1 min-w-0">
      <p className="font-medium text-sm">{delivery.event}</p>
      <p className="text-xs text-muted-foreground truncate">
        {new Date(delivery.created_at).toLocaleString('pt-BR')}
      </p>
    </div>
    <div className="text-right">
      {delivery.response_code && (
        <Badge variant={delivery.response_code < 300 ? 'default' : 'destructive'}>
          {delivery.response_code}
        </Badge>
      )}
      {delivery.error_message && (
        <p className="text-xs text-red-400 truncate max-w-[150px]">{delivery.error_message}</p>
      )}
    </div>
  </div>
);

export default DeliveryRow;
